<template>
  <div class="">
    <iframe id="iframe" :src="`/forms-configure.html?api_base_url=${apiBaseUrl}&api_key=${apiKey}`" ref="iframe"></iframe>
  </div>
</template>

<script>
export default {
  data: () => ({
    apiBaseUrl: "https://v1022.stormport-beta.nz",
    apiKey: "x7Y1Bbrr7JMePSUxHOkZ1CFzC6RD2tlu",
  }),
};
</script>

<style scoped>
iframe {
  height: calc(100vh - 50px);
  width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Forms/configure/index.vue